import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "@/components/Sidebar";
import { Toaster } from "sonner";
import useTheme, { resolveTheme } from "@/hooks/stores/useTheme";
import FloatingCornerActions from "@/components/FloatingCornerActions";
import useAuth from "@/hooks/stores/useAuth";

export function Layout() {
  const { theme } = useTheme();
  const resolvedTheme = resolveTheme(theme);
  const { isAuthenticated, userRole } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window !== "undefined"
      ? !window.matchMedia("(max-width: 767px)").matches
      : true,
  );
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const hideSidebar = userRole?.toLowerCase() === "company";

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 1466);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      {isAuthenticated ? (
        <div className="flex">
          {!hideSidebar && <Sidebar sidebarToggleAction={setIsSidebarOpen} />}
          <div
            className={`flex-1 transition-all duration-300 ${
              !hideSidebar && isSidebarOpen ? "md:ml-[300px] ml-0" : "ml-0"
            }`}
          >
            <main
              className={`mx-auto w-auto ${
                isSmallScreen
                  ? "max-w-[87%]"
                  : !hideSidebar && isSidebarOpen
                    ? ""
                    : "max-w-[94%]"
              }`}
            >
              <Outlet />
            </main>
          </div>
        </div>
      ) : (
        <main>
          <Outlet />
        </main>
      )}

      <FloatingCornerActions />
      <Toaster theme={resolvedTheme} richColors />
    </div>
  );
}
